<div class="avatar" >
  @if (!showInitials) {
    <img src="{{photoUrl()}}" alt="photo">
  }

  @else {
    <div class="initials">
      {{ initials }}
    </div>
  }
</div>